<template>
  <div class="public-dashboard">
    <div class="row">
      <div class="col-md-8 col-md-push-4">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Next 5 Reservations</h1>
          </div>
          <div class="box-body">
            <div v-if="hasLatestReservations">
              <template v-for="reservation in latestReservations">
                <reservation-item v-if="$index == 0" :account-uuid="accountUuid" :reservation="reservation"></reservation-item>
                <div v-else class="box-item">
                  <reservation-item-mini :account-uuid="accountUuid" :reservation="reservation"></reservation-item-mini>
                </div>
              </template>
            </div>
            <div v-if="!hasLatestReservations">
              <div class="alert alert-info">
                You do not have any upcoming reservations
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-md-pull-8">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Dashboard</h1>
          </div>
          <div class="box-body">
            <template v-if="restricted">
              <br/>
              <div class="alert alert-danger">
                <h4><span class="fa fa-fw fa-exclamation-triangle"></span>Account Restricted</h4>
                <p>Your account is currently restricted. You will still be charged any membership fees but will be unable to make any new reservations.</p>
                <p>Call 1300 575 878 for more information.</p>
              </div>
            </template>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Member Documents</h1>
          </div>
          <div class="box-body">
            <p><strong>To view the Membership User Agreement, please click <a :href="$root.muaUrl" target="_blank">here.</a></strong></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Cancel Reservation Modal -->
    <modal v-if="cancelModalActive" v-el:cancel-modal>
      <template slot="header">
        Cancel Reservation
      </template>
      <template slot="body">
        <div class="alert alert-danger">Are you sure you want to cancel your reservation?</div>
        <br/><br/>
        <div class="box-item">
          <div class="media-left">
            <img class="media-object" style="height:100px;" v-bind:src="'https://techcar-dev.s3.amazonaws.com/' + object.reservation.Car.CarType.AmazonImage.objectKey" alt="{{ object.reservation.Car.CarType.name }}">
          </div>
          <div class="media-body">
            <h4 class="list-group-item-heading">Reservation #{{ object.reservation.reservationId }}</h4>
            <p>
              <strong>Start:</strong> {{ object.reservation.startDate | date_format object.reservation.Lot.timezone }}<br/>
              <strong>End:</strong> {{ object.reservation.endDate | date_format object.reservation.Lot.timezone }}
            </p>
          </div>
        </div>
        <template v-if="!business">
          <p v-if="!refundCharge" class="alert alert-danger">
            This booking begins within 24 hours and was not made within the last hour, charges will not be refunded
          </p>
          <p v-if="refundCharge" class="alert alert-info">
            Cancellation of this booking will result in a full refund of charges made to your credit card
          </p>
        </template>
        <template v-if="business">
          <p v-if="!refundCharge" class="alert alert-danger">
            This booking begins within 24 hours and was not made within the last hour, charges will not be refunded to the selected payment method
          </p>
          <p v-if="refundCharge" class="alert alert-info">
            Cancellation of this booking will result in a full refund of charges made to the payment method
          </p>
        </template>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
        <button class="btn btn-danger" @click="confirmCancelReservation">Cancel Booking</button>
      </template>
    </modal>
    <!-- Modify Reservation Modal -->
    <modal v-if="modModalActive" v-el:modify-modal>
      <template slot="header">
        Modify Reservation
      </template>
      <template slot="body">
        <template v-if="!business">
          <p v-if="!refundCharge" class="alert alert-danger">
            This booking begins within 24 hours and was not made within the last hour or has already begun; charges will not be refunded
          </p>
          <p v-if="refundCharge" class="alert alert-warning">
            Partial refunds cannot be made to your credit card, modification of this booking will result in refund of charges made to your account credit balance. Should you wish to receive a full refund, you can cancel the booking
          </p>
        </template>
        <template v-if="business">
          <p v-if="!refundCharge" class="alert alert-danger">
            This booking begins within 24 hours and was not made within the last hour or has already begun; charges will not be refunded to the selected payment method.
          </p>
          <p v-if="refundCharge" class="alert alert-warning">
            Cancellation of this booking will result in a full refund of charges made to the selected payment method.
          </p>
        </template>
        <div class="alert alert-info">Please select the new times for your reservation:</div>
        <div class="car-details clearfix">
          <center>
          <img v-bind:src="'https://techcar-dev.s3.amazonaws.com/' + object.reservation.Car.CarType.AmazonImage.objectKey"/>
          <p>
            <strong>{{ object.reservation.Car.CarType.name }} (#{{ object.reservation.Car.convadisId }} - {{ object.reservation.Car.name }})</strong>
          </p>
          </center>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <strong><span class="fa fa-map-marker"></span> ADDRESS</strong><br/>
            <input class="form-control" type="text" :value="object.reservation.Lot.address" readonly />
          </div>
        </div><br/>
        <div class="row" v-if="oneWayTrips">
          <div class="col-sm-12">
            <strong><span class="fa fa-map-marker"></span> RETURN CAR TO</strong><br/>
            <template v-if="!canChangeEndPoint">
              <input class="form-control" type="text" :value="object.reservation.DestinationLot.address" readonly />
              <p class="yellow">
                <span class="fa fa-exclamation-triangle"></span> End point cannot be modified because {{ object.reservation.started ? 'your booking has started' : 'there has been a future booking made on this bay' }}.
              </p>
            </template>
          </div>
          <object-select-input v-if="canChangeEndPoint"
            :field.sync="availableLots">
          </object-select-input>
        </div>
        <br/>
        <div class="callout callout-success">
          <date-time-range-input v-ref:date-time :field.sync="field"></date-time-range-input>
        </div>
        <reservation-promo-input
          v-ref:promo
          :field="object.promo"
          :user="object.driverUuid"
          :date="object.reservation"
          :car="object.carUuid"
          :read-only="true">
	       </reservation-promo-input>
        <price-breakdown :object.sync="object"></price-breakdown>
        <h4>Memo:</h4>
        <textarea-input :field.sync="memo"></textarea-input>
        <div v-if="!validModification" class="alert alert-danger">
          <template v-if="conflictingReservations.length == 0">
            <span class="fa fa-exclamation-triangle"></span> {{ invalidMessage }}
          </template>
          <template v-else>
            There is a conflict with your selected times and the following reservations:
            <template v-for="reservation in conflictingReservations">
              <p><strong>{{ reservation.startDate | date_format reservation.Lot.timezone }} - {{ reservation.endDate | date_format reservation.Lot.timezone }}</strong></p>
            </template>
          </template>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <span class="form-validation-error" v-show="!$refs.dateTime.valid">
              <span class="fa fa times"></span>
              You have selected an invalid time for this booking.
            </span>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
        <button class="btn btn-default" :disabled="!$refs.dateTime.valid || !validModification" @click="confirmModifyReservation">Modify Booking</button>
      </template>
    </modal>
    <!-- Error Modal -->
    <error-modal v-if="errorModalActive" :error-message="reservationError"></error-modal>
  </div>
</template>

<script>
import DateTimeRangeInput from '../inputs/DateTimeRangeInput.vue'
import ErrorModal from '../modals/ErrorModal.vue'
import Modal from '../Modal.vue'
import PagingInput from '../inputs/PagingInput'
import PriceBreakdown from '../displays/PriceBreakdown.vue'
import ReservationItem from '../displays/ReservationItem.vue'
import ReservationItemMini from '../displays/ReservationItemMini.vue'
import ReservationPromoInput from '../inputs/ReservationPromoInput.vue'
import ObjectSelectInput from '../inputs/ObjectSelectInput.vue'
import TextareaInput from '../inputs/TextareaInput.vue'
import '../../vendor/datetime.min.js'

export default {
  name: 'PublicDashboard',
  components: {
    DateTimeRangeInput,
    ErrorModal,
    Modal,
    PagingInput,
    PriceBreakdown,
    ReservationItem,
    ReservationItemMini,
    ReservationPromoInput,
    TextareaInput,
    ObjectSelectInput
  },
  data () {
    return {
      availableLots: {
        value: '',
        objects: [],
        objectName: 'label'
      },
      oneWayTrips: false,
      canChangeEndPoint: false,
      invalidMessage: '',
      refundCharge: false,
      business: false,
      accountUuid: '',
      latestReservation: {},
      latestReservations: [],
      hasLatestReservations: false,
      conflictingReservations: [],
      validModification: false,
      originalReservation: {},
      cancelModalActive: false,
      modModalActive: false,
      errorModalActive: false,
      object: {
        driverUuid: '',
        allowsFinanceCodes: false,
        businessReservation: false,
        carUuid: '',
        cost: {},
        extras: [],
        cards: {
          required: true,
          valid: false,
          dirty: true
        },
        rate: {},
        reservation: {
          Car: {
            convadisId: '',
            name: '',
            Lot: {
              address: ''
            },
            CarType: {
              name: '',
              AmazonImage: {
                objectKey: 'spacer.gif'
              }
            }
          }
        },
        extraCredit: 0,
        financeCode: {
          name: 'financeCode',
          label: 'Finance Code',
          value: '',
          objects: [],
          objectName: 'dropdownLabel',
          valid: false,
          dirty: false,
          required: true
        },
        promo: {
          label: 'Promotional Code',
          name: 'promo',
          value: '',
          dirty: false,
          valid: false,
          required: false
        }
      },
      businessReservation: false,
      selectedCard: {},
      memo: {
        dirty: true,
        valid: true,
        name: 'memo',
        value: '',
        height: '100px'
      },
      field: {},
      restricted: false
    }
  },
  events: {
    dateTimeChanged () {
      this.$refs.promo.validateField()
      this.updateCost()
    }
  },
  route: {
    async data () {
      if (this.$root.loggedIn) {
        $('body').removeClass('sidebar-collapse').addClass('sidebar-open')
        this.$root.loggedIn = false
      }
      await this.getReservations()
      await this.getAccountStatus()
    }
  },
  methods: {
    async getAvailableLots () {
      return this.$http.post(`${this.$route.authType}/available-bays`, {
        carId: this.object.reservation.CarUuid,
        startDate: this.object.reservation.startDate,
        endDate: this.object.reservation.endDate,
        lat: this.object.reservation.Lot.latitude,
        long: this.object.reservation.Lot.longitude
      })
    },
    async checkLotConflicts () {
      return this.$http.get(`${this.$route.authType}/check-lot-conflicts`, {
        params: {
          lotUuid: this.object.reservation.DestinationLotUuid,
          carUuid: this.object.reservation.CarUuid,
          endDate: this.object.reservation.endDate
        }
      })
    },
    async getAccountStatus () {
      let authType = this.$route.authType
      let { data } = await this.$http.get(`${authType}/get-account-status`)
      this.restricted = data.restricted
    },
    async confirmCancelReservation () {
      let authType = this.$route.authType
      try {
        await this.$http.post(`${authType}/cancel-reservation`, {
          reservationId: this.object.reservation.reservationId
        })
        $(this.$els.cancelModal).modal('toggle')
        this.$nextTick(function () {
          this.getReservations()
        })
      } catch (err) {
        $(this.$els.cancelModal).modal('toggle')
        this.errorModal(err.body)
      }
    },
    async confirmModifyReservation () {
      let authType = this.$route.authType
      this.object.reservation.memo = this.memo.value
      let useCredits = true
      if (this.object.businessReservation || this.object.reservation.FinanceCodeUuid) {
        useCredits = false
      }
      try {
        await this.$http.post(`${authType}/modify-reservation`, {
          reservation: this.object.reservation,
          destinationLotUuid: this.availableLots.value || this.object.reservation.DestinationLotUuid,
          extraCredit: this.object.extraCredit,
          selectedCard: this.selectedCard,
          useCredits
        })
        $(this.$els.modifyModal).modal('toggle')
        await this.getReservations()
      } catch (err) {
        $(this.$els.modifyModal).modal('toggle')
        this.errorModal(err.body)
      }
    },
    async cancelReservationModal (reservation) {
      let authType = this.$route.authType
      this.object.reservation = $.extend(true, {}, reservation)
      let { data } = await this.$http.post(`${authType}/cancel-reservation/validation`, {
        reservationId: this.object.reservation.reservationId
      })
      this.refundCharge = data.refundCharge
      this.business = data.business
      this.cancelModalActive = true
      this.$nextTick(function () {
        $(this.$els.cancelModal).modal()
        $(this.$els.cancelModal).on('hidden.bs.modal', () => {
          this.cancelModalActive = false
        })
      })
    },
    async modifyReservationModal (reservation) {
      this.originalReservation = $.extend(true, {}, reservation)
      this.object.reservation = $.extend(true, {}, reservation)
      this.availableLots.value = this.object.reservation.DestinationLotUuid
      this.oneWayTrips = this.$root.oneWayTrips && this.object.reservation.Car.oneWayTrips && this.object.reservation.Lot.oneWayTrips
      if (!this.object.reservation.started && this.oneWayTrips) {
        let { data } = await this.checkLotConflicts()
        this.canChangeEndPoint = data.length === 0
      } else {
        this.canChangeEndPoint = false
      }
      if (this.canChangeEndPoint) {
        let { data } = await this.getAvailableLots()
        this.object.reservation.DestinationLot.label = this.object.reservation.DestinationLot.address + ' [Current]'
        let lots = [this.object.reservation.DestinationLot].concat(data)
        this.availableLots.value = this.object.reservation.DestinationLotUuid
        this.availableLots.objects = lots
      }
      this.object.driverUuid = reservation.AccountUuid
      this.object.promo.value = reservation.ReservationPromo ? reservation.ReservationPromo.code : false
      this.memo.value = this.object.reservation.memo
      let carUuid = this.object.reservation.Car.uuid
      let accountUuid = this.object.reservation.AccountUuid
      let startDate = moment(this.object.reservation.startDate).valueOf()
      let authType = this.$route.authType
      let extras = this.object.reservation.extras
      let endDate = moment(this.object.reservation.endDate).valueOf()
      let extraCredit = this.object.extraCredit
      let useCredits = !this.object.reservation.FinanceCodeUuid && this.object.reservation.isPersonal
      let alreadyPaid = this.object.reservation.quotedCost
      let createdAt = this.object.reservation.createdAt
      let businessReservation = !this.object.reservation.isPersonal
      let modifyReservation = true
      let data = {}
      try {
        let costResponse = await this.$http.post(`${authType}/reserve/costs`, {
          accountUuid,
          carUuid,
          startDate,
          endDate,
          extras,
          extraCredit,
          alreadyPaid,
          createdAt,
          useCredits,
          businessReservation,
          modifyReservation,
          promo: this.object.reservation.ReservationPromo ? this.object.reservation.ReservationPromo.code : null
        })
        data = costResponse.data
      } catch (err) {
        this.errorModal(err.body || err.toString())
      }
      if (data.costs) {
        this.object.allowsFinanceCodes = data.hasFinanceCodes
        if (data.hasFinanceCodes) {
          this.object.financeCode.objects = data.financeCodes
        }
        this.object.cost = data.costs.cost
        this.object.rate = data.costs.rate.rate
        this.object.optionalExtras = data.costs.rate.extras
        this.object.cards = data.cards
      }
      this.object.carUuid = carUuid
      let response = await this.$http.post(`${authType}/cancel-reservation/validation`, { reservationId: this.object.reservation.reservationId })
      let validationData = response.data
      this.refundCharge = validationData.refundCharge
      this.business = validationData.business
      let now = moment()
      let minDate = moment(this.object.reservation.startDate).toDate()
      if (moment(this.object.reservation.startDate).isAfter(now) && !this.object.reservation.started) {
        minDate = now.toDate()
      }
      this.field = {
        startDate: moment(this.object.reservation.startDate).toDate(),
        minDate,
        endDate: moment(this.object.reservation.endDate).toDate(),
        minimumMinutes: this.$root.minimumMinutes,
        maximumDays: this.$root.maximumDays
      }
      this.modModalActive = true
      this.$nextTick(function () {
        this.$broadcast('getReservationInfo')
        $(this.$els.modifyModal).modal()
        $(this.$els.modifyModal).on('hidden.bs.modal', () => {
          this.modModalActive = false
        })
      })
    },
    errorModal (error) {
      this.reservationError = error
      this.errorModalActive = true
      this.$nextTick(function () {
        $('#errorModal').modal()
        $('#errorModal').on('hidden.bs.modal', () => {
          this.errorModalActive = false
        })
      })
    },
    async getReservations () {
      let authType = this.$route.authType
      let { data } = await this.$http.get(`${authType}/dashboard`)
      this.hasLatestReservations = data.reservations.length > 0
      if (this.hasLatestReservations) {
        this.latestReservations = data.reservations
        this.accountUuid = data.accountUuid
      } else {
        this.latestReservations = []
      }
    },
    async updateCost () {
      let carUuid = this.object.reservation.Car.uuid
      let accountUuid = this.object.reservation.AccountUuid
      let startDate = this.field.startDate
      let authType = this.$route.authType
      let extras = this.object.reservation.extras
      let endDate = this.field.endDate
      let extraCredit = this.object.extraCredit
      let alreadyPaid = this.object.reservation.quotedCost
      let createdAt = this.object.reservation.createdAt
      let useCredits = true
      if (this.object.businessReservation || this.object.reservation.FinanceCodeUuid) useCredits = false
      let { data } = await this.$http.post(`${authType}/update-cost`, {
        accountUuid,
        carUuid,
        startDate,
        endDate,
        extras,
        extraCredit,
        alreadyPaid,
        createdAt,
        useCredits,
        promo: this.object.reservation.ReservationPromo ? this.object.reservation.ReservationPromo.code : null
      })
      this.object.cost = data.cost
      this.object.rate = data.rate.rate
      this.object.optionalExtras = data.rate.extras
      this.object.reservation.startDate = this.field.startDate
      this.object.reservation.endDate = this.field.endDate
      await this.validateReservation()
    },
    async validateReservation () {
      let now = moment()
      if ((now.isAfter(moment(this.originalReservation.startDate)) ||
      this.originalReservation.started) &&
      !moment(this.originalReservation.startDate).isSame(moment(this.object.reservation.startDate), 'minute')) {
        this.invalidMessage = 'You are unable to modify the start time of a booking that has already begun or is past the start time.'
        this.validModification = false
      } else if (moment(this.originalReservation.endDate).isSame(moment(this.object.reservation.endDate), 'minute') &&
      moment(this.originalReservation.startDate).isSame(moment(this.object.reservation.startDate), 'minute')) {
        if (this.originalReservation.memo !== this.memo.value || this.object.reservation.DestinationLotUuid !== this.availableLots.value) {
          this.validModification = true
        } else {
          this.validModification = false
          this.invalidMessage = 'You have not modified this reservation'
          this.conflictingReservations = []
        }
      } else {
        let authType = this.$route.authType
        let { data } = await this.$http.post(`${authType}/validate-reservation`, {
          reservation: this.object.reservation
        })
        if (data.conflictingReservations.length === 0) this.validModification = true
        else this.validModification = false
        this.conflictingReservations = data.conflictingReservations
      }
    },
    unlockCar (reservation) {
      let authType = this.$route.authType
      this.$http.post(`${authType}/unlock-reservation`, { reservationId: reservation.reservationId }).then((response, status, request) => {
        this.getReservations()
      }).catch((err) => {
        $(this.$els.cancelModal).modal('toggle')
        this.errorModal(err.body)
      })
    },
    lockCar (reservation) {
      let authType = this.$route.authType
      this.$http.post(`${authType}/lock-reservation`, { reservationId: reservation.reservationId }).then((response, status, request) => {
        this.getReservations()
      }).catch((err) => {
        $(this.$els.cancelModal).modal('toggle')
        this.errorModal(err.body)
      })
    }
  },
  watch: {
    'object.cards.value': function (newVal, oldVal) {
      this.object.cards.objects.forEach(card => {
        if (card.uuid === this.object.cards.value) {
          this.selectedCard = card
          if (card.cardType === 'Business') {
            this.object.businessReservation = true
          } else {
            this.object.businessReservation = false
          }
        }
      })
      this.updateCost()
    },
    'availableLots.value': function (newVal, oldVal) {
      this.validateReservation()
    },
    'memo.value': function (newVal, oldVal) {
      this.validateReservation()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?84936df2